import React from "react";

/** Marchio di Payroll: i due archi. `inverted` per gli sfondi blu. */
export function BrandMark({ size = 32, inverted = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
      <g
        fill="none"
        stroke={inverted ? "#ffffff" : "var(--pr-primary)"}
        strokeWidth="42"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M 110.38 211.72 A 180 120 0 0 1 401.62 211.72" />
        <path d="M 110.38 350.72 A 180 120 0 0 1 401.62 350.72" />
      </g>
    </svg>
  );
}
